/** @jsx jsx */
import { jsx } from "theme-ui"
import { Link as GatsbyLink } from "gatsby"
import { ReactNode } from "react"

export default function Link({to, children, ssx={}, inline,}: {
  to: string;
  children: ReactNode;
  ssx?: {};
  inline?: boolean;
}) {
    return <GatsbyLink to={to} 
      sx={{
        display: inline ? 'inline-block' : 'block',
        textDecoration: 'none',
        fontSize: 2,
        lineHeight: 'body',
        fontFamily: 'body',
        color: 'secondary',
        ...ssx
    }}>{children}</GatsbyLink>
}

export function AnchorLink({to, children,}) {
  return <a href={`#${to}`} sx={{
    fontSize: 2,
    lineHeight: 'body',
    fontFamily: 'body',
    color: 'secondary',
  }} onClick={e => {
    e.preventDefault()

    window.scrollTo({top: document.getElementById(to)?.offsetTop, behavior: 'smooth'})
  }}>{children}</a>
}

export function ClickableText({onClick, children, ssx={},}: {
  onClick: () => void;
  children: ReactNode;
  ssx?: {};
}) {
  return <a
  sx={{
      fontSize: 2,
      lineHeight: 'body',
      fontFamily: 'body',
      color: 'secondary',
      textDecoration: 'none',
      cursor: 'pointer',
      display: 'block',
      ...ssx
  }} onClick={e => {
    e.preventDefault()
    onClick(e)
  }}>{children}</a>
}

export function ExternalLink({href, children, target, ssx={},}: {
  href: string;
  children: ReactNode;
  ssx?: object;
  target?: '_blank';
}) {
    return <a
      target={target}
      href={href.indexOf('http') === 0 ? href : 'https://' + href}
      sx={{
        display: 'block',
        fontSize: 2,
        lineHeight: 'body',
        fontFamily: 'body',
        ...ssx
      }} 
    >{children}</a>
}

export function InstagramLink({topic, profile,}) {
    if (profile && profile.indexOf('@') === 0) {
      profile = profile.substring(1);
    }
  
    return <div style={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap',}}>
      <ExternalLink href={topic ? 'https://www.instagram.com/explore/tags/' + topic : 'https://www.instagram.com/' + profile}>
        {!!topic ? '#' + topic : '@' + profile}
      </ExternalLink>
    </div>
  }